export interface DashboardStateModel {
  sidenav: boolean;
  header: boolean;
  footer: boolean;
}

export const defaultState: DashboardStateModel = {
  sidenav: false,
  header: false,
  footer: false,
};
